import BoxPlotChart from './BoxPlotChart';

export default BoxPlotChart;
